import { TRUCKLINE } from "./action";

const initialState = {
  trucksList: [],
  truckCreated: {},
  selectedTruck: {},
  truckUpdated: {},
  suggestedTrucklist: []
};

export default function trucklineReducer(state = initialState, action) {
  switch (action.type) {
    case TRUCKLINE.getAllTrucklinesList.success:
      return {
        ...state,
        trucksList: action.data,
        suggestedTrucklist: action.suggestedData,
        truckCreated: {},
        truckUpdated: {}
      };
    case TRUCKLINE.create.success:
      return {
        ...state,
        truckCreated: action.data
      };
    case TRUCKLINE.edit.success:
      return {
        ...state,
        selectedTruck: action.data
      };
    case TRUCKLINE.update.success:
      return {
        ...state,
        truckUpdated: action.data
      };
    case TRUCKLINE.delete.success:
      const truckId = action.data.id;
      return {
        ...state,
        trucksList: state.trucksList.filter(truck => truck.id !== truckId)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/truckline/reducer.js